import alt from 'components/Dispatcher';

/**
 * SharingActions are actions related to the sharing of calls
 */
class SharingActions {
  constructor() {
    this.generateActions(
      'closeSharingDialog',
      'shareFileUpload',
      'shareFileUploadError',
      'shareFileUploadLoading',
      'shareFileUploadSuccess',
      'showSharingDialog',
      'sharingDataChanged',
      'switchTabs'
    );
  }
}

export default alt.createActions(SharingActions);
